import { Injectable, signal } from '@angular/core';

export type MekanicsTheme = 'mekanics' | 'mekanics-dark';
const STORAGE_KEY = 'mk-theme';

/**
 * Gestiona el tema daisyUI de Mekanics Manager (claro/oscuro)
 * aplicándolo a <html data-theme> y persistiéndolo en localStorage.
 */
@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly theme = signal<MekanicsTheme>('mekanics');

  constructor() {
    let initial: MekanicsTheme = 'mekanics';
    try {
      const saved = localStorage.getItem(STORAGE_KEY) as MekanicsTheme | null;
      if (saved === 'mekanics' || saved === 'mekanics-dark') initial = saved;
    } catch {
      /* localStorage no disponible (SSR / modo privado): tema por defecto */
    }
    this.apply(initial);
  }

  isDark(): boolean {
    return this.theme() === 'mekanics-dark';
  }

  toggle(): void {
    this.apply(this.isDark() ? 'mekanics' : 'mekanics-dark');
  }

  apply(theme: MekanicsTheme): void {
    this.theme.set(theme);
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      /* sin persistencia disponible */
    }
  }
}
